import React from "react";
import styled from "styled-components";

const GridContainer = styled.div`
    position: absolute;
    margin: 10px;
    display: grid;
    grid-template-columns: 140px 140px repeat(${props => props.columns - 1}, 1fr);
    grid-template-rows: repeat(${props => props.rows}, minmax(70px, 70px));
`;

const GridItem = styled.div`
    border: lightgrey solid;
    border-width: 0 0.2px 0.2px 0.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const StickyGridItem = styled(GridItem)`
    position: sticky;
    z-index: 2;
    top: 0;
    background-color: white;
    height: 100%;
    flex-direction: column;
`;

const LegendWrapper = styled.div`
    display: flex;
    cursor: default;
`;

const ColorLegendCell = styled(StickyGridItem)`
    display: flex;
    flex-direction: column;
    font-size: 15px;
    justify-content: flex-start;
    align-items: flex-start;
`;

const ColorLegendDiv = styled.div`
    width: 15px;
    height: 15px;
    margin-top: 4px;
    margin-right: 5px;

    &&& {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
    }
`;

const ColorLegendDivRent = styled(ColorLegendDiv)`
    background-color: rgba(149, 117, 205, 0.9);
`;

const ColorLegendDivReservation = styled(ColorLegendDiv)`
    background-color: rgba(225, 190, 231, 0.7);
`;

const ColorLegendDivPool = styled(ColorLegendDiv)`
    background-color: rgba(187, 222, 251, 0.7);
`;

const CarsViewWrapper = ({
    callBackCarImageRef,
    callBackGridContainedRef,
    callBackCarDetailRef,
    rows,
    columns,
    children
}) => (
        <GridContainer
            style={columns * 35 > window.innerWidth ? {} : {width: '99%'}}
            ref={(ref) => callBackGridContainedRef(ref)}
            rows={rows}
            columns={columns}
        >

            <ColorLegendCell ref={(ref) => callBackCarImageRef(ref)}>
                <LegendWrapper>
                    <ColorLegendDivRent />
                    <span> - Wynajem</span>
                </LegendWrapper>
                <LegendWrapper>
                    <ColorLegendDivReservation />
                    <span> - Rezerwacja</span>
                </LegendWrapper>
                <LegendWrapper>
                    <ColorLegendDivPool />
                    <span> - Pool</span>
                </LegendWrapper>
            </ColorLegendCell>

            <StickyGridItem ref={(ref) => callBackCarDetailRef(ref)}/>

            { children }

        </GridContainer>
    )

export default CarsViewWrapper
